import { createContext, useContext } from "react";
import dappConfig from "@/../config/dapp.config";

export type SupUiTheme = "light" | "dark" | "up-only-dark" | "up-only-light" | "teal";

interface ContextProps {
  theme?: SupUiTheme;
  toggleTheme?: (theme: SupUiTheme) => void;
}

const Context = createContext<ContextProps>({ theme: dappConfig.defaultTheme });

export const ThemeProvider = Context.Provider;

export function useTheme() {
  return useContext(Context);
}
